import PropTypes from 'prop-types';
import React from 'react';
import { AppContainer } from 'react-hot-loader';
import { Provider } from 'react-redux';
import { IdentifyGeo } from './common/containers/country-code';

import '@glowforge/ui-common/main.css';

const Wrapper = ({ store, children }) => (
  <AppContainer>
    <Provider store={store}>
      <React.Fragment>
        <IdentifyGeo />
        { children }
      </React.Fragment>
    </Provider>
  </AppContainer>
);

Wrapper.propTypes = {
  store: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  children: PropTypes.element.isRequired,
};

export default Wrapper;



// WEBPACK FOOTER //
// ./app/wrapper.jsx